import { render, staticRenderFns } from "./ProspectDetail.vue?vue&type=template&id=1f9e5c9a&scoped=true"
import script from "./ProspectDetail.vue?vue&type=script&lang=js"
export * from "./ProspectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProspectDetail.vue?vue&type=style&index=0&id=1f9e5c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e5c9a",
  null
  
)

export default component.exports